export default __webpack_public_path__ + "static/media/anim.ba26e6ac.gif";